// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
    apiKey: "AIzaSyByz8iHGqjX6griISn3PM8_TJjprEkL2co",
    authDomain: "express-app-166ee.firebaseapp.com",
    projectId: "express-app-166ee",
    storageBucket: "express-app-166ee.firebasestorage.app",
    messagingSenderId: "318441122825",
    appId: "1:318441122825:web:a80abf12b8a75050bd1cd8",
    measurementId: "G-W3T28C2E2F"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();